import ClipboardDollarIcon from '../assets/images/icons/clipboard-dollar.svg';
import { identity } from '@gplibraries/react/identity';

const { roles, groups } = identity;

export const appTilesConfig = {
  appTileSize: '160px',
  tiles: [
    {
      href: '/dealer_access/part_manager.php',
      title: 'Order Parts',
      icon: { glyph: 'nut-fill' },
      external: true,
      allowedRoles: [roles.CS_USER, roles.TM, roles.PARTS],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    // {
    //   href: '/dealer_access/applications/eservice/',
    //   external: true,
    //   title: 'E-Service',
    //   icon: { glyph: 'tools' },
    //   allowedRoles: [roles.CS_USER, roles.TM, roles.SERVICE],
    //   allowedGroups: [groups.ADMINS, groups.DEALERS]
    // },
    {
      href: '/dealer_access/applications/ewarranty',
      title: 'E-Warranty',
      external: true,
      icon: { glyph: 'card-checklist' },
      allowedRoles: [roles.CS_USER, roles.TM, roles.SERVICE, roles.WARRANTY],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    {
      href: '/dealer_access/warranty_reg.php',
      title: 'Warranty Registration',
      icon: { glyph: 'pencil-square' },
      external: true,
      allowedRoles: [roles.CS_USER, roles.TM, roles.WARRANTY, roles.SALES_MARKETING, roles.SERVICE, roles.WHOLEGOODS, roles.CREDIT],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    {
      href: 'https://ww2.e-billexpress.com/ebpp/LandPride/Login/Index',
      title: 'Pay Invoice',
      external: true,
      icon: { glyph: 'credit-card' },
      allowedRoles: [roles.CS_USER, roles.TM, roles.CREDIT],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    {
      href: '/bulletins',
      title: 'Bulletins',
      icon: { glyph: 'pin-angle-fill' }
    },
    {
      href: '/dealer_access/applications/coopAdvertisingCreditRequest/',
      external: true,
      title: 'Submit Co-op',
      icon: { glyph: 'receipt-cutoff' },
      allowedRoles: [roles.CS_USER, roles.TM, roles.SALES_MARKETING, roles.CREDIT],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    {
      href: '/content/forms/rebate',
      title: 'Rebate Request',
      icon: { src: ClipboardDollarIcon },
      external: true,
      allowedRoles: [roles.CS_USER, roles.TM, roles.SALES_MARKETING, roles.CREDIT, roles.WHOLEGOODS],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    {
      href: '/content/forms/product-quote-request',
      title: 'Gov Quote Request',
      icon: { glyph: 'bank' },
      external: true,
      allowedRoles: [roles.CS_USER, roles.TM, roles.GOVERNMENT_CONTRACTS],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    {
      href: '/bargain-warehouse',
      title: 'Bargain Warehouse',
      icon: { glyph: 'shop' },
      allowedRoles: [roles.CS_USER, roles.TM, roles.SALES_MARKETING, roles.CREDIT, roles.WHOLEGOODS],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    // {
    //   href: '/',
    //   title: 'Contact Us',
    //   icon: { glyph: 'telephone-outbound' }
    // },

  ]

}